/**
 * Angular imports.
 */
import { ChangeDetectionStrategy, Component, Input, TemplateRef } from '@angular/core';

/**
 * Used to show the custom template using template ref.
 */
@Component({
  selector: 'app-custom-component',
  templateUrl: './custom-component.component.html',
  styleUrls: ['./custom-component.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CustomComponentComponent {

  /**
   * Get custom template using template ref.
   */
  @Input() customComponent: TemplateRef<HTMLElement>;

}
